module.exports = __webpack_public_path__ + "img/seedback-white.e05a600d.svg";